import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import DownloadModalTables from "../../components/DownloadModalTables";
import PortalPopup from "../../components/PortalPopup";
import FeesFilter from "../../components/FeesFilter";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import NavigationPanel from "../../components/NavigationPanel";
import CTAs from "../../components/CTAs";
import Footer from "../../components/Footer";

const OutcomeAndCostPage_2 = () => {
  const navigate = useNavigate();
  const [isDownloadModalTablesOpen, setDownloadModalTablesOpen] =
    useState(false);
  const [isFeesFilterOpen, setFeesFilterOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const openDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(true);
  }, []);

  const closeDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(false);
  }, []);

  const openFeesFilter = useCallback(() => {
    setFeesFilterOpen(true);
  }, []);

  const closeFeesFilter = useCallback(() => {
    setFeesFilterOpen(false);
  }, []);

  const onClickOutcomeUpdates = useCallback(() => {
    navigate("/outcome&cost");
  }, [navigate]);

  const onClickJudgementPhase = useCallback(() => {
    navigate("/outcome&cost3");
  }, [navigate]);

  const onClickClientCommunication = useCallback(() => {
    navigate("/outcome&cost4");
  }, [navigate]);

  const onClickReportingAndAnalytics = useCallback(() => {
    navigate("/outcome&cost5");
  }, [navigate]);

  const openLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(true);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const navItems = [
    {
      text: "Debt collection",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "",
      icon: "assets/arrow-down.svg",
    },

    {
      text: "Outcomes & costs",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
      icon: "",
    },

    {
      text: "AI indicators",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/ai1",
      icon: "",
    },
  ];

  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const cost_implication = [
    { id: 1, claimId: "1", solicitor_fees: "£3000", court_fees: "£500" },
    { id: 2, claimId: "2", solicitor_fees: "£1500", court_fees: "£400" },
    { id: 3, claimId: "3", solicitor_fees: "£6500", court_fees: "£350" },
    { id: 4, claimId: "4", solicitor_fees: "£3000", court_fees: "£500" },
    { id: 5, claimId: "5", solicitor_fees: "£3000", court_fees: "£500" },
    { id: 6, claimId: "6", solicitor_fees: "£3000", court_fees: "£500" },
    { id: 7, claimId: "7", solicitor_fees: "£3000", court_fees: "£500" },
    { id: 8, claimId: "8", solicitor_fees: "£3000", court_fees: "£500" },
    { id: 9, claimId: "9", solicitor_fees: "£3000", court_fees: "£500" },
    { id: 10, claimId: "10", solicitor_fees: "£3000", court_fees: "£500" },
  ];

  const filteredDebtors =
    activeTab === "all"
      ? cost_implication
      : cost_implication.filter(
          (debtor) => debtor.status.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedDebtors = filteredDebtors.filter(
    (debtor) =>
      debtor.claimId.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.solicitor_fees.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.court_fees.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-sm text-neutrals-neutral-300 font-open-sans-ff-meta">
        <NavigationPanel navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 text-neutrals-neutral-900 px-4 md:px-4 lg:px-24 box-border">
          {/* Heading */}
          <b className="self-stretch relative text-9xl">{`Outcomes & costs`}</b>

          {/* Tabs */}
          <div className="flex flex-row items-start justify-start gap-6 text-base text-Neutrals-neutral-300">
            <div
              className="bg-white h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickOutcomeUpdates}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Outcome updates</div>
              </div>
            </div>
            <div className="bg-white border-primary-primary-500 border-solid border-b-[2px] box-border h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 text-primary-primary-500">
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Cost implications</div>
              </div>
            </div>
            <div
              className="bg-white h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickJudgementPhase}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Judgement phase</div>
              </div>
            </div>
            <div
              className="bg-white h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickClientCommunication}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">
                  Client communication
                </div>
              </div>
            </div>
            <div
              className="bg-white h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickReportingAndAnalytics}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">{`Reporting & analytics`}</div>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] flex flex-col items-start justify-start text-sm">
            <div className="w-full rounded-t-3xs rounded-b-none box-border flex flex-row items-center justify-between py-5 px-6 text-lg border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-l-[1px]">
              <div className="flex flex-row items-center justify-start gap-[10px]">
                <div className="relative font-semibold">Cost implications</div>
                <div className="rounded-md bg-neutrals-neutral-50 flex flex-row items-center justify-start py-0.5 px-2 gap-[6px] text-sm border-[1px] border-solid border-neutrals-neutral-100">
                  <div className="w-1.5 relative rounded-[50%] bg-primary-primary-500 h-1.5" />
                  <div className="relative font-semibold">10 claims</div>
                </div>
              </div>
              <CTAs
                type="Secondarybtn"
                text="Download"
                borderColor="border-neutrals-neutral-100"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M9 11v6l2-2M9 17l-2-2"
                      stroke="#2d404e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5"
                      stroke="#2d404e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M22 10h-4c-3 0-4-1-4-4V2l8 8Z"
                      stroke="#2d404e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                }
                position="relative"
                onClick={openDownloadModalTables}
              />
            </div>
            <div className="w-full box-border flex flex-row items-start justify-end py-3 px-6 text-neutrals-neutral-300 border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-l-[1px]">
              <div className="w-full flex flex-row items-start justify-between">
                <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-row items-center justify-start py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                  <div className="flex flex-row items-center justify-start gap-[10px]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.5 21a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19ZM22 22l-2-2"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <div className="relative">Search your claims</div>
                  </div>
                </div>
                <CTAs
                  type="Secondarybtn"
                  text="Filter"
                  borderColor="border-neutrals-neutral-100"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M3 7h18M6 12h12M10 17h4"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      ></path>
                    </svg>
                  }
                  position="relative"
                  onClick={openFeesFilter}
                />
              </div>
            </div>
            <div className="w-full flex flex-col items-start justify-start">
              <div className="self-stretch flex flex-col items-start justify-start">
                <div className="self-stretch flex flex-row items-start justify-start">
                  <table className="min-w-full divide-y divide-gray-200 border-collapse">
                    <thead className="bg-column-bg">
                      <tr>
                        <th
                          scope="col"
                          className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                        >
                          Claim Id
                        </th>
                        <th
                          scope="col"
                          className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                        >
                          Solicitor Fees
                        </th>
                        <th
                          scope="col"
                          className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-r-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                        >
                          Court Fees
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-neutrals-neutral-50 divide-y divide-gray-200">
                      {searchedDebtors.map((cost_implication) => (
                        <tr key={cost_implication.id} className="hover:bg-gray">
                          <td className="p-4 items-start border-solid border-b-[1px] border-l-[1px] border-neutrals-neutral-100">
                            {cost_implication.claimId}
                          </td>
                          <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                            {cost_implication.solicitor_fees}
                          </td>
                          <td className="p-4 items-start border-solid border-b-[1px] border-r-[1px] border-neutrals-neutral-100">
                            {cost_implication.court_fees}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-full rounded-t-none rounded-b-3xs box-border flex flex-row items-center justify-between pt-3 px-6 pb-4 border-r-[1px] border-solid border-neutrals-neutral-100 border-b-[1px] border-l-[1px]">
                <CTAs
                  type="Secondarybtn"
                  text="Previous"
                  borderColor="border-neutrals-neutral-100"
                />
                <div className="relative">Page 1 of 10</div>
                <CTAs
                  type="Secondarybtn"
                  text="Next"
                  borderColor="border-neutrals-neutral-100"
                />
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      {isDownloadModalTablesOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeDownloadModalTables}
        >
          <DownloadModalTables onClose={closeDownloadModalTables} />
        </PortalPopup>
      )}
      {isFeesFilterOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeFeesFilter}
        >
          <FeesFilter onClose={closeFeesFilter} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default OutcomeAndCostPage_2;
